import Vue from 'vue'
import moment from 'moment'

const $filters = {
    capitalize (value) {
        if (!value) return '';
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
    capitalizeAll (value) {
        return value.split(' ').map(item => $filters.capitalize(item)).join(' ')
    },
    toCapitalize (str) {
        return $filters.capitalize(str.toLowerCase())
    },
    formatNumber (value, currency = '') {
        // format number 1234567 to 1,234,567
        try {
            return value.toString()
                .replace(/\D/g, '')
                .replace(/\B(?=(\d{3})+(?!\d))/g, currency === 'USD' ? ',' : '.')
        } catch (e) {
            return ''
        }
    },
    formatDateTime (date) {
        if (!date) return null;
        // 2019-05-17T08:16:58.310Z"
        let fmt = 'YYYY-MM-DD HH:mm:ss';
        let m = moment.utc(date, fmt);
        m.local();
        return m.format(fmt)
    },
    formatDate (date) {
        if (!date) return null;
        // 2019-05-17T08:16:58.310Z"
        let fmt = 'YYYY-MM-DD';
        let m = moment.utc(date, fmt);
        m.local();
        return m.format(fmt)
    },
    formatTime (date) {
        if (!date) return null;
        // 2019-05-17T08:16:58.310Z"
        let fmt = 'YYYY-MM-DD';
        let m = moment.utc(date, fmt);
        m.local();
        return m.format('HH:mm')
    }
};

Vue.filter('capitalize', $filters.capitalize);
Vue.filter('capitalizeAll', $filters.capitalizeAll);
Vue.filter('toCapitalize', $filters.toCapitalize);
Vue.filter('formatNumber', $filters.formatNumber);
Vue.filter('formatDateTime', $filters.formatDateTime);
Vue.filter('formatDate', $filters.formatDate);
Vue.filter('formatTime', $filters.formatTime);

Vue.prototype.$filters = $filters;
export default $filters
